/**
 * @generated SignedSource<<f1ef33940b63b6d156ea0394074cf8ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RestartContentNodeAfterFailedInput = {
  clientMutationId?: string | null;
  contentNodeId: string;
};
export type NavigateDirectToQuestionsAdvanceContentButton_RestartContentNodeAfterNotYetPassedMutation$variables = {
  input: RestartContentNodeAfterFailedInput;
};
export type NavigateDirectToQuestionsAdvanceContentButton_RestartContentNodeAfterNotYetPassedMutation$data = {
  readonly LearnV2: {
    readonly restartContentNodeAfterFailed: {
      readonly contentSubmission: {
        readonly id: string;
      };
    } | null;
  };
};
export type NavigateDirectToQuestionsAdvanceContentButton_RestartContentNodeAfterNotYetPassedMutation = {
  response: NavigateDirectToQuestionsAdvanceContentButton_RestartContentNodeAfterNotYetPassedMutation$data;
  variables: NavigateDirectToQuestionsAdvanceContentButton_RestartContentNodeAfterNotYetPassedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnV2Mutations",
    "kind": "LinkedField",
    "name": "LearnV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "RestartContentNodeAfterFailedPayload",
        "kind": "LinkedField",
        "name": "restartContentNodeAfterFailed",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentSubmission",
            "kind": "LinkedField",
            "name": "contentSubmission",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NavigateDirectToQuestionsAdvanceContentButton_RestartContentNodeAfterNotYetPassedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NavigateDirectToQuestionsAdvanceContentButton_RestartContentNodeAfterNotYetPassedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "67a76dc99bf86493088cae01df181da3",
    "id": null,
    "metadata": {},
    "name": "NavigateDirectToQuestionsAdvanceContentButton_RestartContentNodeAfterNotYetPassedMutation",
    "operationKind": "mutation",
    "text": "mutation NavigateDirectToQuestionsAdvanceContentButton_RestartContentNodeAfterNotYetPassedMutation(\n  $input: RestartContentNodeAfterFailedInput!\n) {\n  LearnV2 {\n    restartContentNodeAfterFailed(input: $input) {\n      contentSubmission {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1aabeecd41e2818eff98083783fd9732";

export default node;
